/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_CountryInputs */

const cs_form_country = /** @type {(inputs: Form_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kód země`)
};

const en_form_country = /** @type {(inputs: Form_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country code`)
};

/**
* | output |
* | --- |
* | "Country code" |
*
* @param {Form_CountryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_country = /** @type {((inputs?: Form_CountryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_CountryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_country(inputs)
	return cs_form_country(inputs)
});